/*@flow*/
import React from 'react';
import omit from 'ramda/src/omit';

type Props = {
  keyField: string,
  isSelected: (string) => any,
  toggleSelection: (any, any, Object) => void,
  selectAll: boolean,
  toggleAll: Function,
  columns: string[],
};

function CheckboxHOC(Component: React$ComponentType<*>): any {
  return class RTCheckboxTable extends React.Component<Props> {
    static defaultProps = {
      keyField: '_id',
      isSelected: (key: string) => {
        console.log('No isSelected handler provided:', { key });
      },
      selectAll: false,
      toggleSelection: (key: string, shift: any, row: Object) => {
        console.log('No toggleSelection handler provided:', {
          key,
          shift,
          row,
        });
      },
      toggleAll: () => {
        console.log('No toggleAll handler provided.');
      },
    };

    // we only need a Component so we can get the 'ref' - pure components can't get a 'ref'

    wrappedInstance: React$Node;
    wrappedInstance = null;

    rowSelector = (row: Object) => {
      if (
        !row ||
        !Object.prototype.hasOwnProperty.call(row, this.props.keyField)
      ) {
        return null;
      }
      const checked = this.props.isSelected(row[this.props.keyField]);
      return (
        <input
          type="checkbox"
          checked={checked}
          onClick={(e) => {
            const { shiftKey } = e;
            e.stopPropagation();
            this.props.toggleSelection(row[this.props.keyField], shiftKey, row);
          }}
          onChange={() => {}}
          value=""
        />
      );
    };

    headSelector = () => {
      const checked = this.props.selectAll;
      return (
        <input
          type="checkbox"
          checked={checked}
          onClick={(e) => {
            e.stopPropagation();
            this.props.toggleAll();
          }}
          onChange={() => {}}
          value=""
        />
      );
    };

    // this is so we can expose the underlying ReactTable to get at the sortedData for selectAll
    getWrappedInstance = () => this.wrappedInstance;

    render() {
      const { columns: originalCols } = this.props;
      const rest = omit([
        'columns',
        'isSelected',
        'toggleSelection',
        'toggleAll',
        'keyField',
        'selectAll',
      ])(this.props);

      const { rowSelector, headSelector } = this;
      const select = {
        id: '_selector',
        accessor: () => 'x', // this value is not important
        Header: headSelector,
        Cell: (ci) => {
          return rowSelector(ci.original);
        },
        width: 30,
        filterable: false,
        sortable: false,
        resizable: false,
        style: { textAlign: 'center' },
      };
      const columns = [select, ...originalCols];
      const extra = {
        columns,
      };
      return (
        <Component
          {...rest}
          {...extra}
          ref={(r) => (this.wrappedInstance = r)}
        />
      );
    }
  };
}

export default CheckboxHOC;
